<template lang="pug">
    .columns.is-centered
        .column.is-half-desktop
            form.hero#login-form(@submit.prevent="loginHandler")
                .field
                    label.label.is-unselectable(for="email") E-mail
                .field
                    .control
                        input.input#email(name="email" type="email" v-model="email" placeholder="E-mail")
                .field
                    label.label.is-unselectable(for="password") Password
                .field.has-addons
                    .control.is-expanded.has-icon-right
                        input.input#password(name="password" :type="passwordInputType" v-model="password" placeholder="Password")
                    .control
                        button.button(type="button" title="Show password" :class="{'is-danger': showPassword }"
                            @click="showPassword=!showPassword" v-show="!showPassword")
                            span.icon
                                i.fas.fa-eye
                        button.button.is-danger(type="button" title="Show password"
                            @click="showPassword=!showPassword" v-show="showPassword")
                            span.icon(v-show="showPassword")
                                i.fas.fa-eye-slash
                .field
                    .level.is-mobile
                        .level-left
                            button.button.is-primary(type="submit" :class="{ 'is-loading': inProcess }") Enter
                        .level-right
                            router-link.is-link(to="/forgot" :class="{ 'attention': loginAttempts >= 3 }") Forgot?
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      email: "",
      password: "",
      inProcess: false,
      showPassword: false,
      loginAttempts: 0
    };
  },
  computed: {
    passwordInputType() {
      return this.showPassword ? "text" : "password";
    }
  },
  methods: {
    loginHandler() {
      this.inProcess = true;
      const email = this.email;
      const password = this.password;
      this.$store
        .dispatch("login", { email, password })
        .then(res => {
          if (res) this.checkSession();
        })
        .catch(text => {
          this.loginAttempts += 1;
          if (this.loginAttempts > 3) this.loginAttempts = 0;
          this.$notify({
            type: "error",
            title: "Error",
            text
          });
        })
        .finally(() => {
          this.inProcess = false;
        });
    }
  }
};
</script>
